<template>
  <div class="loanable-form-car-state">
    <p>{{ $t("components.loanable.form.car_state.description") }}</p>
    <i18n path="components.loanable.form.car_state.download_report_template" tag="p">
      <template #report_template>
        <a :href="$t('resources.car_state_report_template_url')" target="_blank" download>
          {{ $t("components.loanable.form.car_state.report_template") }}
          <b-icon icon="download" />
        </a>
      </template>
    </i18n>
    <i18n path="components.loanable.form.car_state.place_report_in_logbook" tag="p">
      <template #logbook>
        <a :href="$t('components.loanable.form.car_state.logbook_url')" target="_blank" download
          >{{ $t("components.loanable.form.car_state.logbook") }}
          <b-icon icon="download" />
        </a>
      </template>
    </i18n>
    <forms-validated-input
      v-model="item.details.has_report_in_notebook"
      type="checkbox"
      :rules="{
        accepted: item.published || validatePublishing,
      }"
      name="has_report_in_notebook"
      :label="$t('components.loanable.form.car_state.placed_report_in_logbook')"
    />
    <p>
      {{ $t("components.loanable.form.car_state.upload_report") }}
    </p>
    <forms-validated-input
      v-model="item.details.report"
      :label="$t('cars.fields.report') | capitalize"
      :rules="{ required: item.published || validatePublishing }"
      name="report"
      type="file"
    />
    <p>{{ $t("components.loanable.form.car_state.keep_updated") }}</p>
  </div>
</template>

<script>
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";

export default {
  name: "LoanableFormCarState",
  components: {
    FormsValidatedInput,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validatePublishing: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
